module.exports = __webpack_public_path__ + "static/media/acerca_de_hibou.d9484142.gif";